import { CSSObject } from '@emotion/react'
import { colors } from '@opallabs/spectrum'

// Styling for preview wrapper
const getPreviewWrapper = (isTooltipActive: boolean): CSSObject => ({
  position: 'relative',
  overflow: 'hidden',
  width: '100%',
  maxWidth: '550px',
  '.kuiper-preview-wrapper:hover .kuiper-settings-icon-wrapper': {
    opacity: '95%',
    height: '16px',
    transitionDelay: '0.2s',
  },
  '.kuiper-settings-icon-wrapper': {
    opacity: isTooltipActive ? '95%' : 0,
    height: isTooltipActive ? '16px' : 0,
    transitionDelay: '0.2s',
  },
  '.kuiper-icon-cog-lg': {
    transition: 'color 0.2s ease-in',
    color: isTooltipActive ? colors.n10.base : colors.n6.base,
  },
  '.kuiper-settings-icon-wrapper-trigger:hover': {
    '.kuiper-icon-cog-lg': {
      color: colors.n10.base,
    },
  },
})

// Styling for preview
const getPreview = (isEmbedlyPreview: boolean): CSSObject => ({
  border: isEmbedlyPreview ? 0 : '1px solid #E1E8ED',
  borderRadius: '14px',
  margin: isEmbedlyPreview ? '-10px 0' : 0,
  pointerEvents: isEmbedlyPreview ? 'none' : 'auto',
  img: {
    borderRadius: '14px',
  },
})

// Styling for settings icon wrapper
const settingsIconWrapper: CSSObject = {
  borderRadius: '0 0 14px 14px',
  padding: '10px',
  backgroundColor: colors.n3.base,
  position: 'absolute',
  opacity: '0',
  height: '0',
  bottom: '0',
  cursor: 'pointer',
  transition: 'height 0.2s ease-out, opacity 0.2s ease-out',
  width: 'calc(100% - 20px)',
}

// Styling for settings icon to box in tooltip
const settingsIcon: CSSObject = {
  height: '16px',
  width: '16px',
}

// Styling for loader to unset positioning and background
const loaderWrapper: CSSObject = {
  padding: '16px 10px 16px 10px',
  borderRadius: '14px',
  backgroundColor: colors.n10.base,
  position: 'absolute',
  height: '100%',
  width: '100%',
  '.kuiper-loader-container': {
    position: 'unset',
    margin: '9px 0 9px 0',
  },
}

const styles = {
  getPreviewWrapper,
  getPreview,
  settingsIconWrapper,
  settingsIcon,
  loaderWrapper,
}

export { styles }
